import { getDatasWithOption, handleApiError } from '../../utils/service';
import { isDefined, isNotDefined, truthy, getUriCombinedParams, parseInt10, isPetNecklace } from '../../utils/util';
import { getLoadingBarTpl } from '../../model/tpl/loadingbar';
import { NO_ITEM_IMAGE_URL } from '../../model/model';
import { BOARD } from '../../model/msg/board';
import Navi from '../../component/navi/Navi';

class Item {
  constructor(options) {
    const _ = this;

    if (!options) return;

    _.ITEM_LINK_PATH = '/world/item/detail';

    _.option = $.extend({
      wrap: null,
      apiDomain: '',
      global: window
    }, options);

    _.wrap = _.option.wrap;

    _.articleWrap = $('article', _.wrap);

    _.favoriteItemWrap = null;

    _.equipmentItemWrap = null;

    _.navi = null;

    _.currentNaviIndex = 1;

    _.isFavoriteNoData = false;
    _.isEquipmentNoData = false;

    _.tpl = {
      SET_FAVORITE_ITEM: `<div class="nodata">
                            <p>관심이 가는 아이템은 시세 검색후<br /> <strong>'관심 아이템'</strong>으로 등록해 보세요.</p>
                            <a href="/world/item/index">시세</a>
                          </div>`
    };
  }

  init() {
    const _ = this;

    _.favoriteItemWrap = $(`<ul></ul>`);
    _.equipmentItemWrap = $(`<ul></ul>`);

    _.articleWrap.empty()
      .append(_.favoriteItemWrap)
      .append(_.equipmentItemWrap);

    _.setInstance();

    return _;
  }

  setInstance() {
    const _ = this;

    _.setNavi();
    _.navi.activate(_.currentNaviIndex);

    _.setItemData('favorite');
    _.setItemData('equipment');
  }

  setNoData(serviceName) {
    const _ = this;

    switch (serviceName) {
      case 'equipment' :
        _.isEquipmentNoData = true;
        break;

      case 'favorite' :
        _.isFavoriteNoData = true;
        break;
    }

    if (isNotDefined(_.isFavoriteNoData) && _.isEquipmentNoData) {
      _.equipmentItemWrap.remove();

      _.navi.activate(1);
      $('header .equipment', _.wrap).remove(); // remove navi btn

    } else if (_.isFavoriteNoData && isNotDefined(_.isEquipmentNoData)) {
      _.favoriteItemWrap.remove();

      _.navi.activate(2);
      $('header .favorite', _.wrap).remove(); // remove navi btn

    } else if (_.isFavoriteNoData && _.isEquipmentNoData) {
      $('article', _.wrap).append(_.tpl.SET_FAVORITE_ITEM);

      _.navi.destroy();
      $('header menu', _.wrap).remove(); // remove all navi btns
    }
  }

  setItemData(serviceName) {
    const _ = this,
      wrap = _[`${serviceName}ItemWrap`];

    _.setLoadingBar(wrap, true);

    getDatasWithOption([{
      type: 'GET',
      url: `${_.option.apiDomain}/api/main/marketprice/${serviceName}`,
      dataType: 'json',
      xhrFields: {withCredentials: true}

    }], (data) => {
      _.setLoadingBar(wrap, false);

      switch (serviceName) {
        case 'favorite' :
          _.setFavoriteItemList(data);
          break;

        case 'equipment' :
          _.setEquipmentItemList(data);
          break;
      }

    }, (data) => {
      handleApiError(data);

      _.setLoadingBar(wrap, false);

      switch (serviceName) {
        case 'favorite' :
          wrap.empty().append(`<li class="nodata">${BOARD.RETRY_LATER}</li>`);
          break;

        case 'equipment' :
          wrap.empty().append(`<li class="nodata">${BOARD.RETRY_LATER}</li>`);
          break;
      }
    });
  }

  setFavoriteItemList(data) {
    const _ = this;
    _.userDataServerId = window.userData.gameAccount.serverId  || 1 ;

    if (!data || !Array.isArray(data.list) || data.list.length <= 0) {
      _.setNoData('favorite');
      return;
    }

    const items = data.list;

    let tpl = '', element;
    for (let i = 0, max = items.length; i < max; ++i) {
      element = items[i];

      if (isNotDefined(element)) continue;

      // example) http://opdev.lineage.plaync.com/world/item/detail?itemId=25&tradeType=BUY&enchant=0&itemStatus=NORMAL
      let sellItemUrl = getUriCombinedParams(_.ITEM_LINK_PATH, {
          serverId: _.userDataServerId,
          itemId: element.itemId || '',
          tradeType: 'SELL'
        });

      // if(isPetNecklace(element.itemId)) {
        sellItemUrl = getUriCombinedParams(sellItemUrl, {
          info: element.info,
          elenchant: element.elenchant,
          enchant: element.enchant,
          itemAttribute: element.itemAttribute.name,
          itemStatus: element.itemStatus.name
        });
      // }

      let sellLow = (element.sellLowestPrice) ? element.sellLowestPrice : '',
        sellHigh = (element.sellHighestPrice) ? element.sellHighestPrice : '',
        sellItemPrice = (parseInt10(sellLow) === 0 && parseInt10(sellHigh) === 0) ? '-' : `${sellLow} ~ ${sellHigh}`, // (sellLow || sellHigh) ? `${sellLow} ~ ${sellHigh}` : '-',
        sellTpl = `<div class="item__sell">
                      <a href="${sellItemUrl}" tabindex="0">
                        <span class="label">판매</span>
                        <strong>${sellItemPrice}</strong>
                      </a>
                    </div>`;

      let buyItemUrl = getUriCombinedParams(_.ITEM_LINK_PATH, {
          serverId: _.userDataServerId,
          itemId: element.itemId || '',
          tradeType: 'BUY'
        });

      //if(isPetNecklace(element.itemId)) {
        buyItemUrl = getUriCombinedParams(buyItemUrl, {
          info: element.info,
          elenchant: element.elenchant,
          enchant: element.enchant,
          itemAttribute: element.itemAttribute.name,
          itemStatus: element.itemStatus.name
        });
      //}

      let buyLow = (element.buyLowestPrice) ? element.buyLowestPrice : '',
        buyHigh = (element.buyHighestPrice) ? element.buyHighestPrice : '',
        buyItemPrice = (parseInt10(buyLow) === 0 && parseInt10(buyHigh) === 0) ? '-' : `${buyLow} ~ ${buyHigh}`, // (buyLow || buyHigh) ? `${buyLow} ~ ${buyHigh}` : '-',
        buyTpl = `<div class="item__buy">
                      <a href="${buyItemUrl}" tabindex="0">
                        <span class="label">구매</span>
                        <strong>${buyItemPrice}</strong>
                      </a>
                    </div>`;

      tpl += `<li>
                <div class="item__thumb">
                  <img src="${element.itemImageUrl}" onerror="this.onerror=null; this.src='${NO_ITEM_IMAGE_URL}'">
                </div>
                ${sellTpl}
                ${buyTpl}
              </li>`;
    }

    _.favoriteItemWrap.empty().append(tpl);
  }

  setEquipmentItemList(data) {
    const _ = this;
    _.userDataServerId = window.userData.gameAccount.serverId  || 1 ;

    if (!data || !Array.isArray(data.list) || data.list.length <= 0) {
      _.setNoData('equipment');
      return;
    }

    const items = data.list;

    let tpl = '', element;
    for (let i = 0, max = items.length; i < max; ++i) {
      element = items[i];

      if (isNotDefined(element)) continue;

      // example) http://opdev.lineage.plaync.com/world/item/detail?itemId=25&tradeType=BUY&enchant=0&itemStatus=NORMAL
      let sellItemUrl = getUriCombinedParams(_.ITEM_LINK_PATH, {
          serverId: _.userDataServerId,
          itemId: element.itemId || '',
          tradeType: 'SELL'
        });

      //if(isPetNecklace(element.itemId)) {
        sellItemUrl = getUriCombinedParams(sellItemUrl, {
          info: element.info,
          elenchant: element.elenchant,
          enchant: element.enchant,
          itemAttribute: element.itemAttribute.name,
          itemStatus: element.itemStatus.name
        });
      //}

      let sellLow = (element.sellLowestPrice) ? element.sellLowestPrice : '',
        sellHigh = (element.sellHighestPrice) ? element.sellHighestPrice : '',
        sellItemPrice = (parseInt10(sellLow) === 0 && parseInt10(sellHigh) === 0) ? '-' : `${sellLow} ~ ${sellHigh}`, // (sellLow || sellHigh) ? `${sellLow} ~ ${sellHigh}` : '-',
        sellTpl = `<div class="item__sell">
                      <a href="${sellItemUrl}" tabindex="0">
                        <span class="label">판매</span>
                        <strong>${sellItemPrice}</strong>
                      </a>
                    </div>`;

      let buyItemUrl = getUriCombinedParams(_.ITEM_LINK_PATH, {
          serverId: _.userDataServerId,
          itemId: element.itemId || '',
          tradeType: 'BUY'
        });

      //if(isPetNecklace(element.itemId)) {
        buyItemUrl = getUriCombinedParams(buyItemUrl, {
          info: element.info,
          elenchant: element.elenchant,
          enchant: element.enchant,
          itemAttribute: element.itemAttribute.name,
          itemStatus: element.itemStatus.name
        });
      //}

      let buyLow = (element.buyLowestPrice) ? element.buyLowestPrice : '',
        buyHigh = (element.buyHighestPrice) ? element.buyHighestPrice : '',
        buyItemPrice = (parseInt10(buyLow) === 0 && parseInt10(buyHigh) === 0) ? '-' : `${buyLow} ~ ${buyHigh}`, // (buyLow || buyHigh) ? `${buyLow} ~ ${buyHigh}` : '-',
        buyTpl = `<div class="item__buy">
                      <a href="${buyItemUrl}" tabindex="0">
                        <span class="label">구매</span>
                        <strong>${buyItemPrice}</strong>
                      </a>
                    </div>`;

      tpl += `<li>
                <div class="item__thumb">
                  <img src="${element.itemImageUrl}" onerror="this.onerror=null; this.src='${NO_ITEM_IMAGE_URL}'">
                </div>
                ${sellTpl}
                ${buyTpl}
              </li>`;
    }

    _.equipmentItemWrap.empty().append(tpl);
  }

  setNavi() {
    const _ = this;

    _.navi = new Navi({
      btns: $('header li a', _.wrap),
      activateCallback: function (obj) {
        let btns = $(_.navi.getBtns()),
          btn = $(_.navi.getBtn(obj.index));

        btns.parent().removeClass('on');
        btn.parent().addClass('on');

        let serviceName = _.getServiceNameByNavi(btn.parent());
        _.switchItemsWrap(serviceName);
      }
    }).init();
  }

  getServiceNameByNavi(btnParent) {
    const classes = $(btnParent).attr('class').split(' '),
      serviceName = (classes.indexOf('favorite') >= 0) ? 'favorite' : 'equipment';

    return serviceName;
  }

  switchItemsWrap(serviceName) {
    const _ = this;

    switch (serviceName) {
      case 'favorite' :
        _.favoriteItemWrap.show();
        _.equipmentItemWrap.hide();
        break;

      case 'equipment' :
        _.favoriteItemWrap.hide();
        _.equipmentItemWrap.show();
        break;
    }
  }

  setLoadingBar(wrap, flag) {
    $('.loadingbar', wrap).remove();

    if (truthy(flag)) $(wrap).append(getLoadingBarTpl());
  }
}

export default Item;


// WEBPACK FOOTER //
// ./_src/js/main/my/Item.js